<div class="swapa-podcast-block" *ngIf="config && config.Title">
    <div *ngIf="config.ThumbnailUrl" class="swapa-podcast-block-thumbnail">
        <img [src]="config.ThumbnailUrl" [alt]="config.ThumbnailAltText" />
    </div>
    <div class="swapa-podcast-block-body">
        <p class="swapa-podcast-block-label">Podcast</p>
        <h3 class="swapa-podcast-block-title" [title]="config.Title">
            <a *ngIf="config.TitleLinkUrl; else plainTitle" [href]="config.TitleLinkUrl">{{ config.Title }}</a>
            <ng-template #plainTitle>{{ config.Title }}</ng-template>
        </h3>
        <p class="swapa-podcast-block-summary" *ngIf="config.Summary"
           [clampTooltip]="config.Summary">{{ config.Summary }}</p>
        <div class="swapa-podcast-block-actions" *ngIf="config.AudioUrl || config.SeeMoreLinkUrl">
            <ng-container *ngIf="config.AudioUrl">
                <button type="button"
                        class="swapa-podcast-block-play"
                        [attr.aria-label]="(isPlaying ? 'Pause' : 'Play') + ' podcast: ' + config.Title"
                        [attr.aria-pressed]="isPlaying"
                        (click)="togglePlay()">
                    <svg *ngIf="!isPlaying" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M8 5v14l11-7z" /></svg>
                    <svg *ngIf="isPlaying" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M6 4h4v16H6V4zm8 0h4v16h-4V4z" /></svg>
                </button>
                <audio #audio
                       preload="none"
                       [src]="config.AudioUrl"
                       (play)="isPlaying = true"
                       (pause)="isPlaying = false"
                       (ended)="isPlaying = false"></audio>
            </ng-container>
            <a *ngIf="config.SeeMoreLinkUrl" class="swapa-podcast-block-see-more" [href]="config.SeeMoreLinkUrl">{{ config.SeeMoreText }}</a>
        </div>
    </div>
</div>
